import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux";
import { Button, Label } from "reactstrap";
import { ApplicationState } from "store";
import { permissionsGetRequest, roleGetRequest, roleNameListRequest } from "store/role/action";
import { userGetRequest } from "store/auth/action";
import Profile from "./Profile";
import { useNavigate } from "react-router";
import NotificationSettings from "./Notification/NotificationSettings";
import MeetingAccount from "./innerComponents/MeetingAccount";
import NewReview from "./NewReview";
import WorkingHoursForm from "./innerComponents/WorkingHours";
import UserSkillsSetup from "./Skills/UserSkillsSetup";

const menuItems = [
    { label: "userpreferences.profile", icon: "ri-user-3-fill", category: "general", key: "profile" },
    { label: "userpreferences.access", icon: "ri-shield-keyhole-fill", category: "general", key: "access" },
    { label: "Working Hours", icon: "ri-time-fill", category: "general", key: "working_hours" },
    { label: "userpreferences.connected_accounts", icon: "ri-user-shared-fill", category: "general", key: "accounts" },
    { label: "userpreferences.notifications", icon: "ri-notification-2-fill", category: "system", key: "notifications" },
    { label: "Skills", icon: "ri-focus-2-fill", category: "general", key: "skills" },
];

const groupedItems = menuItems.reduce((acc: Record<string, typeof menuItems>, item) => {
    acc[item.category] = acc[item.category] || [];
    acc[item.category].push(item);
    return acc;
}, {});

const UserDetailsNew = ({ t }: any) => {
    const navigate = useNavigate();
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const user = useSelector((state: ApplicationState) => state.auth?.userProfile);
    const roleDetails: any = useSelector((state: ApplicationState) => state.role.roleDetails);
        const permissionsdata = useSelector(
            (state: ApplicationState) => state.role.permissionsdata
        );
    const [activeItem, setActiveItem] = useState<string>("profile");

    useEffect(() => {
        dispatch(userGetRequest())
        dispatch(roleNameListRequest())
    }, [])

        useEffect(() => {
            dispatch(permissionsGetRequest());
            dispatch(roleGetRequest(user.role.id));
        }, [dispatch, user.role.id]);

    const goBack = () => {
        navigate(-1);
    };
    const Sidebar = ({ t, goBack }: any) => (
        <aside className="d-flex flex-column vh-100 p-3" style={{ minWidth: "250px" }}>
            <div className="text-primary mb-3">
                <div>
                    <Button outline color="primary" className="btn-sm ms-n3 hstack btn-ghost-primary align-items-center fw-bold fs-14" onClick={() => goBack()}>
                        <i className="ri-arrow-left-s-line"></i><span>Back</span>
                    </Button>
                </div>
            </div>
            <nav className="flex-grow-1">
                {Object.entries(groupedItems).map(([category, items]) => (
                    <div key={category} className="mb-3">
                        <div className="text-uppercase fw-semibold text-muted small mb-2">
                            <Label className="mb-0">{t(`${category}`) || category}</Label>
                        </div>
                        {items.map(({ label, icon, key }) => (
                            <div
                                key={label}
                                onClick={() => setActiveItem(key)}
                                className={`rounded p-2 d-flex align-items-center mb-2 ${activeItem === key ? "bg-primary-subtle text-primary" : "bg-light-subtle"}`}
                                style={{ cursor: "pointer" }}
                            >
                                <Button color="light" className={`btn-icon btn-sm me-2 ${activeItem === key ? "bg-light-subtle text-muted" : "bg-primary-subtle"}`}> <i className={`${icon} text-primary fs-5`}></i> </Button>
                                
                                <span><Label className="mb-0">{t(label)}</Label></span>
                            </div>
                        ))}
                    </div>
                ))}
            </nav>
        </aside>
    );

    return (
        <div className="d-flex bg-light-subtle rounded-3" style={{ minHeight: "100vh" }}>
            <Sidebar t={t} goBack={goBack} />
            <div className="flex-grow-1 d-flex flex-column me-n2">
                <main className="p-0 bg-light flex-grow-1">
                    {activeItem === "profile" && <Profile />}
                    {activeItem === "working_hours" && <WorkingHoursForm t={t} user={user} />}
                    {activeItem === "accounts" && <MeetingAccount />}
                    {activeItem === "notifications" && <NotificationSettings />}
                    {activeItem === "skills" &&  <UserSkillsSetup />}
                    {activeItem === "access" && (
                        user && (user.role.title === 'Owner' || user.role.title === 'owner') ? (
                            <div className="d-flex justify-content-center align-items-center">
                                <p className="my-5 fs-20 fw-bold">{t("userpreferences.owner_has_all")}</p>
                            </div>
                        ) : (
                            <NewReview />
                        )
                    )}
                </main>
            </div>
        </div>
    )
}
export default withTranslation()(UserDetailsNew)